/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import http from '@/common/http'
import { Menu } from '@/hooks/useMenus'
import { PostLogin200 } from '@/types/schemas/dashboard.schemas'

//account
export function login(user: { passwd: string; name: string }): Promise<PostLogin200> {
  return http.post('/manager/guest/sign_in', user)
}

// menu
export async function menus(): Promise<Array<Menu>> {
  const data = await http.post('/manager/menus/ex')
  return data.menus
}

// Menus
export function menusv1(params = {}) {
  return http.post('/manager/menus', params)
}

export function logout(username: string, backend: 'ldap' | 'local' = 'local') {
  return http.post(`/manager/sign_out`)
}

// SignOut 用户登出
export function signOut(params = {}) {
  return http.post('/manager/sign_out', params)
}

// GetMenus
export function getMenus(params = {}) {
  return http.post('/manager/menus/ex', params)
}

// Info
export function info(params = {}) {
  return http.post('/manager/info', params)
}
// Roles
export function getRoleList(params = {}) {
  return http.post('/manager/roles', params)
}

// RoleTree
export function getRoleTree(params = {}) {
  return http.post('/manager/role/tree', params)
}
// AddManagerAddRole 添加角色
export function addRole(params = {}) {
  return http.post('/manager/role/add', params)
}
// UpdateRole 添加角色
export function updateRole(params = {}) {
  return http.post('/manager/role/update', params)
}

// BanRole 禁用角色
export function banRole(params = {}) {
  return http.post('/manager/role/ban', params)
}

// Managers
export function getManagers(params = {}) {
  return http.post('/manager/managers', params)
}
// AddManager 添加管理员
export function addManager(params = {}) {
  return http.post('/manager/add', params)
}
// UpdateManager 更新管理员
export function updateManager(params = {}) {
  return http.post('/manager/update', params)
}
// BanManager 禁用管理员
export function banManager(params = {}) {
  return http.post('/manager/ban', params)
}
// DeleteManager 删除管理员
export function deleteManager(params = {}) {
  return http.post('/manager/delete', params)
}
// GenManagerApikey 生成apikey
export function genManagerApikey(params = {}) {
  return http.post('/manager/gen/apikey', params)
}
// GetManagerLogs 获取管理员日志
export function getManagerLogs(params = {}) {
  return http.post('/manager/logs', params)
}
// DataPerms 数据权限
export function getDataPerms(params = {}) {
  return http.post('/manager/data_perms', params)
}
// UploadMedia 上传媒体资源
export function uploadMedia(params = {}) {
  return http.post('/manager/upload_media', params)
}
// SystemInfo 系统信息
export function systemInfo(params = {}) {
  return http.post('/cms/system/info', params)
}
export function changePassword(params = {}) {
  return http.post('/manager/change/passwd', params)
}
